<script lang="ts" setup>
import type { ContentBlock } from '../types'

defineOptions({
  name: 'Page',
})

interface Props {
  contentBlocks?: ContentBlock.Model[]
}

const props = withDefaults(defineProps<Props>(), {
  contentBlocks: () => [],
})

const hasContentBlocks = computed<boolean>(() => props.contentBlocks.length > 0)
</script>

<template>
  <section class="single-page">
    <slot name="beforeContentBlocks" />
    <ContentBlocks
      v-if="hasContentBlocks"
      :content-blocks
      class="single-page__content-blocks"
    />
    <slot name="afterContentBlocks" />
  </section>
</template>
